import { api } from "./axios";

const pitchBodiesApi = {
  getAll: () => api.get("/pitch-body-templates"),
  getOne: (id: string) => api.get(`/pitch-body-templates/${id}`),
  create: (data: { name: string; fields: any[] }) => api.post("/pitch-body-templates/create", data),
  update: (id: string, data: { name: string; fields: any[] }) => api.put(`/pitch-body-templates/update/${id}`, data),
  delete: (id: string) => api.delete(`/pitch-body-templates/${id}`),
};

export default pitchBodiesApi;
